import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface ProductImage {
  id: number;
  image: string;
}

interface ProductGalleryProps {
  images: ProductImage[];
  productName: string;
}

export default function ProductGallery({ images, productName }: ProductGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  const activeImage = images[activeIndex];

  if (!images || images.length === 0) {
    return (
      <div className="flex aspect-square items-center justify-center rounded-3xl bg-slate-50 text-sm text-slate-400">
        No Image
      </div>
    );
  }

  return (
    <div>
      {/* Main image */}
      <div className="relative aspect-square overflow-hidden rounded-3xl bg-slate-50">
        <AnimatePresence mode="wait">
          <motion.img
            key={activeImage.id}
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            src={activeImage.image}
            alt={productName}
            className="h-full w-full object-contain p-8"
          />
        </AnimatePresence>
      </div>

      {/* Thumbnails */}
      {images.length > 1 && (
        <div className="mt-4 flex gap-3">
          {images.map((img, index) => (
            <button
              key={img.id}
              onClick={() => setActiveIndex(index)}
              className={`
                h-20
                w-20

                shrink-0

                overflow-hidden
                rounded-2xl

                bg-slate-50

                transition-all
                duration-200

                ${
                  activeIndex === index
                    ? "ring-2 ring-[#3DA4A8] ring-offset-2"
                    : "opacity-60 hover:opacity-100"
                }
              `}>
              <img src={img.image} alt="" className="h-full w-full object-contain p-2" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
